/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationItem } from '@squiz/sds';
import { DAM_DASHBOARD, FILE_STORE_SCREEN } from './Screens.constants';

/**
 * All navigation items that make up Digital asset management screens.
 */
export const DXP_MENU_DAM_SCREENS: Array<NavigationItem> = [DAM_DASHBOARD, FILE_STORE_SCREEN];
